import styled from '@emotion/styled';
import { N900, N20, N0, B100 } from '@atlaskit/theme/colors';
import { fontFallback } from '@atlaskit/theme/typography';
import { Link } from '@atlassian/search-dialog';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const CenteredAdvancedSearchGroup = styled.div({
  display: 'flex',
  alignItems: 'center'
});
const outlineWidth = 2;

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const StyledAdvancedSearch = styled(Link)(props => ({
  alignItems: 'center',
  color: `var(--ds-text, ${N900})`,
  cursor: 'pointer',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  padding: `${"var(--ds-space-075, 6px)"} ${2 * 8 - outlineWidth}px`,
  border: `${outlineWidth}px solid transparent`,
  '&:hover': {
    color: `var(--ds-text, ${N900})`,
    backgroundColor: `var(--ds-background-neutral, ${N20})`,
    textDecoration: 'none'
  },
  ':visited': {
    color: `var(--ds-text, ${N900})`
  },
  ':focus': {
    outline: 'none',
    border: `${outlineWidth}px solid ${`var(--ds-border-focused, ${B100})`}`
  },
  backgroundColor: props.isKeyboardHighlighted ? `var(--ds-background-neutral, ${N20})` : `var(--ds-background-neutral-subtle, ${N0})`
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const AdvancedSearchContent = styled.span({
  font: `var(--ds-font-body, ${fontFallback.body.medium})`,
  paddingLeft: "var(--ds-space-200, 16px)"
});